export enum PageKind {
    CART = "CartPage",
    CHECKOUT = "CheckoutPage",
    CONTENT = "ContentPage",
    ERROR = "ErrorPage",
    FRONT = "FrontPage",
    LOGIN = "LoginPage",
    NOTFOUND = "NotFoundPage",
    PRODUCT_SERIES = "ProductSeries",
    RECEIPT = "ReceiptPage",
    PRODUCT_PAGE = "ProductPage",
}
